import { Box, Grid, Typography } from '@mui/material';
import Layout from 'features/Layout';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';

export default function contact() {
  const position = { lat: 12.9117432, lng: 77.6442024 };
  return (
    <Layout
      title="Khatabook - Contact Us"
      description="Digital India's Digital Khata! Download Khatabook now & take charge of all your transactions, use Khatabook and grow your business!"
    >
      <style
        dangerouslySetInnerHTML={{
          __html: `.vp-1 {
                min-height: 700px;
                background-size: cover;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .vp-1 {
                min-height: 400px;
                background-size: cover;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            @media (max-width: 1024px) {
              .vp-1 {
                min-height: 180px;
              }
            }

            .red-span {
                color: #C82128;
            }

            .container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}
            #map {
                height: 400px;
                width: 100%;
            }`
        }}
      />
      <Box mb={['2.5rem', '2.5rem', '6.25rem']} mt="6.25rem">
        <section
          className="vp-1 d-flex d-sm-none"
          style={{
            backgroundImage: `url(https://khatabook-assets.s3.amazonaws.com/static/images/contact/contactbg.webp)`
          }}
        >
          <div className="container">
            <h1>We are listening</h1>
          </div>
        </section>
        <section className="container">
          <div style={{ padding: '50px 0' }}>
            <Grid container>
              <Grid xs={12}>
                <Typography variant="h4" component="h4" align="center">
                  We care about you
                </Typography>
              </Grid>
              <Grid xs={12}>
                <Typography variant="subtitle1" component="p" align="center">
                  The Khatabook team offers customer support from 7am to 10pm on
                  all days.
                </Typography>
              </Grid>
              <Grid xs={12}>
                <Typography variant="subtitle1" component="p" align="center">
                  Call us on{' '}
                  <a
                    className="remove-anchor-decoration red-span"
                    href="call:+919606800800"
                  >
                    +91-9606800800
                  </a>{' '}
                  or write to us at{' '}
                  <a
                    className="remove-anchor-decoration red-span"
                    href="mailto:feedback@khatabook.com"
                  >
                    feedback@khatabook.com
                  </a>
                </Typography>
              </Grid>
            </Grid>
          </div>
        </section>
        <section className="container" id="map">
          <APIProvider apiKey={'AIzaSyDT_RA4u7VsWSFb2R-Y1Sq2nhPUwqIrQ5w'}>
            <Map defaultCenter={position} defaultZoom={18}>
              <Marker position={position} />
            </Map>
          </APIProvider>
        </section>
      </Box>
    </Layout>
  );
}
